import { Api } from '@/services/Api'

let lib = {}
lib.getGeneration = (plantId, date) => {
  return Api().get(`/api/v1.0/dgr/generation/${plantId}/${date}`)
}

lib.updateGeneration = (param) => {
  return Api().put('/api/v1.0/dgr/generation', param)
}

lib.getRemarks = (plantId, date) => {
  return Api().get(`/api/v1.0/dgr/remarks/${plantId}/${date}`)
}

lib.updateRemarks = (param) => {
  return Api().put('/api/v1.0/dgr/remarks', param)
}

export default lib
